import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getElectricalListGroups } from '../../../api/electrical-list-groups';

export const getElectricalListGroupsAsync = createAsyncThunk(
  'electricalListGroups/getElectricalListGroups',
  getElectricalListGroups
);

export interface ElectricalListGroup {
  id: number;
  name: string;
  electricalLists: {
    id: number;
    name: string;
    electricalListGroupId: number;
  }[];
}

interface ElectricalListGroupState {
  data: ElectricalListGroup[];
}

const initialState: ElectricalListGroupState = {
  data: []
};

export default createSlice({
  name: 'electricalListGroups',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getElectricalListGroupsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
  }
});
